export default function getOptionLabel(source) {
  let date = '';
  if (source.dateDay) date = date.concat(`${source.dateDay}/`);
  if (source.dateMonth) date = date.concat(`${source.dateMonth}/`);
  if (source.dateYear) date = date.concat(`${source.dateYear}`);
  return `${source.title || ''} - ${date} - ${source.reference || ''}`;
}
